var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"width":"100%","controls":"controls"}},[_c('source',{attrs:{"src":_vm.formattedUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }